<template>
  <div class="max-w-6xl mx-auto">
    <template v-if="showSeries.name && !loading">
      <!--<div class="max-w-6xl bg-white sm:border sm:rounded mx-auto">-->
      <div  v-if="showSeries.series_details.featured_sponsors" class="bg-white p-3 lg:rounded border" >
        <h3 class="text-lg font-semibold text-center mb-3">Featured Sponsors</h3>
        <div class="flex justify-center space-x-10 items-centerd">
          <div v-for="(s,i) in showSeries.series_details.featured_sponsors" :key="i">
            <a :href="s.external_link" target="_blank">
              <img :src="`https://res.cloudinary.com/showman/image/upload/c_scale,h_100/${s.logo_id}`">
            </a>
          </div>
        </div>
      </div>
      <div class="max-w-6xl mx-auto">
        <div class="">
          <div class="lg:max-w-6xl lg:mx-auto px-1 sm:px-6">
            <div class="py-5 md:flex md:items-center md:justify-between">
              <div class="flex-1 min-w-0">
                <!-- Profile -->
                <div class="flex items-center">
                  <img class="hidden h-2- w-40 rounded-lg border-2 sm:block" :src="seriesLogoURL" :alt="`${showSeries.name} Logo`">
                  <div>
                    <div class="flex items-center">
                      <img class="h-32 w-32 rounded-lg sm:hidden" :src="seriesLogoURL" :alt="`${showSeries.name} Logo`">
                      <h1 class="ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate">
                        {{showSeries.name}}
                      </h1>
                    </div>
                    <dl class="mt-6 flex flex-col sm:mt-1 sm:ml-3 sm:flex-row sm:flex-wrap">
                      <dt class="sr-only">Year</dt>
                      <dd class="flex items-center text-sm text-gray-600 font-medium capitalize sm:mr-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p>{{showSeries.series_details.year}}</p>
                      </dd>
                      <dt class="sr-only">Species</dt>
                      <dd class="flex items-center text-sm text-gray-600 font-medium capitalize sm:mr-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0 mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p>{{showSeries.series_details.species}}</p>
                      </dd>
                      <template v-if="showSeries.series_details.show_rules">
                        <dt class="sr-only">Series Rules</dt>
                        <dd class="flex items-center text-sm text-gray-600 font-medium capitalize sm:mr-6">
                          <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          <a v-if="showSeries.series_details.show_rules" class="hover:underline hover:text-blue-600"  target="_blank" :href="showSeries.series_details.show_rules">View Rules</a>
                        </dd>
                      </template>
                      <template v-if="showSeries.series_details.series_flyer">
                        <dt class="sr-only">Series Flyer</dt>
                        <dd class="flex items-center text-sm text-gray-600 font-medium capitalize sm:mr-6">
                          <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                          </svg>
                          <a v-if="showSeries.series_details.series_flyer" class="hover:underline hover:text-blue-600"  target="_blank" :href="showSeries.series_details.series_flyer">Series Flyer</a>
                        </dd>
                      </template>
                      <template v-if="showSeries.series_details.website">
                        <dt class="sr-only">Series Website</dt>
                        <dd class="flex items-center text-sm text-gray-600 font-medium capitalize sm:mr-6">
                          <svg xmlns="http://www.w3.org/2000/svg" class="flex-shrink mr-1 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                          </svg>
                          <a class="hover:underline hover:text-blue-600" :href="showSeries.series_details.website" target="_blank">Series Website</a>
                        </dd>
                      </template>

                    </dl>
                  </div>
                </div>
              </div>
              <div class="mt-6 flex space-x-3 md:mt-0 md:ml-4">
                <a :href="`mailto:${showSeries.series_details.contact_email}`" target="_blank" type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                  Email Series
                </a>
                <router-link v-if="showSeries.series_settings.online_membership" :to="{name: 'show_series.join', params: {show_series: $route.params.show_series}}" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  {{ this.$store.getters.mySeriesMembers.length ? 'My Membership' : `Join Series` }}
                </router-link>
              </div>
            </div>
          </div>
          <div id="tabs">
            <div class="sm:hidden px-2 py-3 border-t border-b bg-gray-200">
              <label for="tabs" class="sr-only">Select a tab</label>
              <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
              <select id="tabs" name="tabs" @change="changeRoute($event)" class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border pl-3 pr-10 py-2  border-gray-300 rounded-md">
                <option v-for="tab in tabs" :key="tab.name" :selected="tab.route === $route.name" :value="tab.route">{{ tab.name }}</option>
              </select>
            </div>
            <div class="hidden sm:block">
              <div class="border-b border-gray-300">
                <nav class="-mb-px flex space-x-8 px-4 sm:px-6" aria-label="Tabs">
                  <router-link v-for="tab in tabs" :key="tab.name" :to="{name: tab.route, params: {show_series: $route.params.show_series}}" :class="[tab.route === $route.name ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-400', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-base']" :aria-current="tab.route === $route.name ? 'page' : undefined">
                    {{ tab.name }}
                  </router-link>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div>
          <router-view class="py-4 px-1 sm:px-3"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card-flat mt-6 max-w-sm mx-auto">
        <vue-simple-spinner size="huge" :speed="1.1" :line-size="5" :font-size="11" message="Loading Series" line-fg-color="orange"/>
      </div>
    </template>
  </div>
</template>

<script>
export default {

  data () {
    return {
      slug: null,
      loading: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.slug = to.params.show_series
      vm.selectedTab = 'Show Details'
      vm.loadSeriesData()
    })
  },
  methods: {
    loadSeriesData () {
      this.loading = true
      this.$store.dispatch('loadCurrentShowSeries', {slug: this.slug})
        .then(() => {
          if (!this.showSeries.show_series_id) {
            // this.$honeybadger.notify(new Error(`Series not found: ${this.slug}`))
            this.notie.alert({
              type: 2,
              text: `Series Not Found<br> See the list of all upcoming shows below.`
            })
            this.$router.push('/show-series')
          }
          this.loading = false
        })
        .catch(() => {
          // console.log(error)
          // this.$honeybadger.notify(error)
          this.notie.alert({
            type: 3,
            text: `There was an error loading this show series, try refreshing your browser.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    changeRoute (event) {
      const name = event.target.value
      this.$router.push({name: name, params: {show_series: this.$route.params.show_series}})
    }
  },
  computed: {
    showSeries () {
      return this.$store.state.showSeries_.currentShowSeries
    },
    currentUser () {
      return this.$store.state.user
    },
    tabs () {
      let tabs = [
        {name: 'Series Home', route: 'show_series.shows'}
      ]
      if (this.showSeries.name) {
        if (this.showSeries.events.length) {
          tabs.push()
          tabs.push({
            name: 'Results', route: 'show_series.results', current: false
          })
        }
        if (this.showSeries.standings && !this.showSeries.series_settings.hide_standings) {
          tabs.push({
            name: 'Series Standings', route: 'show_series.standings', current: false
          })
        }
        if (this.showSeries.sponsor_settings.types) {
          tabs.push({
            name: 'Sponsor Series', route: 'show_series.sponsor', current: false
          })
        }
        if (this.showSeries.series_settings.online_membership) {
          tabs.push({
            name: this.$store.getters.mySeriesMembers.length ? 'My Membership' : 'Join Series',
            route: 'show_series.join',
            current: true
          })
        }
        if (this.viewAdmin) {
          tabs.push({
            name: 'Admin', route: 'show_series.admin', current: false
          })
        }
        if (this.viewSuperUser) {
          tabs.push({
            name: 'Advanced Admin', route: 'show_series.advanced', current: false
          })
        }
      }
      return tabs
    },
    seriesLogoURL () {
      return this.showSeries.series_details ? `https://res.cloudinary.com/showman/image/upload/c_scale,h_300/${this.showSeries.series_details.logo_id}` : '#'
    },
    viewAdmin () {
      if (this.currentUser) {
        return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === this.showSeries.admin_id || this.currentUser.user_id === '9tWzGNjoUZWFjonz2PJJpAnkGxg1' || this.currentUser.user_id === '2S1n15f3I0OJjgpLx5pMlHdAfT13'
      } else {
        return false
      }
    },
    viewSuperUser () {
      if (this.currentUser) {
        return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === '2S1n15f3I0OJjgpLx5pMlHdAfT13'
      } else {
        return false
      }
    },
    apiInstance () {
      return this.$store.state.apiInstance
    }
  }
}
</script>

<style>
  /*.router-link-exact-active {
      border: 5px dashed red;
  } */
</style>
